module.exports = __webpack_public_path__ + "img/hr-ccm-universal-04a-base-sequence.8a48b270.png";